export const TEST_ID = 'navigation';

export const HELP_PAGE = 'https://help.acreconnect.io/en/';
